var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar'),_c('van-nav-bar',{attrs:{"title":_vm.$route.name,"left-arrow":"","right-text":_vm.rigthtText,"fixed":""},on:{"click-right":_vm.rightClick,"click-left":function($event){return _vm.returnMethod()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }